import { request } from 'Apiv2/handleRequest';

const BASE_URL = '/place_contacts';

const defaultReload = () => window.location.reload();

const deletePlaceContactWrapper = (
  requestProvider = request,
  reloadProvider = defaultReload
) => {
  return async (id, { setIsDeleting, setDeleteError }) => {
    try {
      setIsDeleting(true);
      setDeleteError(false);

      const response = await requestProvider(`${BASE_URL}/${id}`, 'DELETE');

      if (response.status !== 204) {
        throw new Error('Request did not process / Server error');
      }

      reloadProvider();
      return;
    } catch (error) {
      setIsDeleting(false);
      setDeleteError(true);
      return;
    }
  };
};

export default deletePlaceContactWrapper;
